<template>
    <div id="header">
        <div id="logo" class="light-version" style="padding:10px 0 0 2px; ">
            <img style="max-width: 100%;" src="@/assets/images/logo-horiz.png"/>
        </div>
        <nav role="navigation">
            <div class="header-link hide-menu"><i class="fa fa-bars"></i></div>
            <div class="dev-msg" v-if="env === 'development' || env === 'staging'">{{env === 'development' ? 'LOCAL' :
                'TEST'}} ENVIRONMENT
            </div>
            <!--<div class="small-logo">
                <img src="@/assets/images/logo-horiz.png"/>
            </div>-->
            <div class="mobile-menu">
                <button type="button" class="navbar-toggle mobile-menu-toggle" data-toggle="collapse"
                        data-target="#mobile-collapse">
                    <i class="fa fa-chevron-down"></i>
                </button>
                <div class="collapse mobile-navbar" id="mobile-collapse">
                    <ul class="nav navbar-nav">
                        <li>
                            <a @click="profile">
                                Perfil
                            </a>
                        </li>
                        <li>
                            <a @click="logout">
                                Cerrar sesión
                            </a>
                        </li>
                    </ul>
                </div>
            </div>
            <div class="navbar-right">
                <ul class="nav navbar-nav no-borders">
                    <li class="dropdown">
                        <a @click="profile" title="Perfil">
                            <i class="pe-7s-user text-info"></i>
                        </a>
                    </li>
                    <li class="dropdown">
                        <a @click="logout" title="Cerrar sesión">
                            <i class="pe-7s-upload pe-rotate-90"></i>
                        </a>
                    </li>
                </ul>
            </div>
        </nav>
    </div>
</template>
<script>
    import {AUTH_LOGOUT} from '../../store/actions/auth'
    import {LOGIN, PROFILE} from "../../router/routes";

    export default {
        data() {
            return {
                env: process.env.NODE_ENV
            }
        },
        methods: {
            logout: function () {
                this.$store.dispatch(AUTH_LOGOUT).then(() => this.$router.push(LOGIN.route))
            },
            profile: function () {
                this.$router.push(PROFILE.route)
            }
        },
        mounted() {
            $('.hide-menu').on('click', function (event) {
                event.preventDefault();
                if ($(window).width() < 769) {
                    $("body").toggleClass("show-sidebar");
                } else {
                    $("body").toggleClass("hide-sidebar");
                }
            });
        }
    }


</script>



// WEBPACK FOOTER //
// src/components/layout/Header.vue